import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { AIConversation } from '../../extViewmodels/sdk/models/AI';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllAIConversationFilterQueries } from './useAIConversationFilterQuery';

export const AI_CONVERSATION_TITLE_MAX_LENGTH = 200;

export function truncateToConversationTitle(text: string) {
	return text.length > AI_CONVERSATION_TITLE_MAX_LENGTH
		? `${text.slice(0, AI_CONVERSATION_TITLE_MAX_LENGTH)}...`
		: text;
}

export function useUpdateAIConversationTitleMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (conversation: AIConversation) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			conversationId,
			title,
			impersonationContext,
		}: {
			conversationId: string;
			title: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<AIConversation>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `aiconversation/${conversationId}/title`,
					impersonationContext,
				}),
				'PATCH',
				{ title }
			);
		},
		onError,
		onSuccess: conversation => {
			invalidateAllAIConversationFilterQueries();
			onSuccess?.(conversation);
		},
	});
}
